// src/components/LanguageToggle.js
import React from 'react';
import styles from '../styles/LanguageToggle.module.css';

// Small EN/AR switch used across the Social Media Content Management pages.
const LanguageToggle = ({ language, onToggle }) => {
  return (
    <div className={styles.toggleGroup} role="group" aria-label="Language switch">
      <button
        type="button"
        className={`${styles.toggleButton} ${language === 'en' ? styles.active : ''}`}
        onClick={() => language !== 'en' && onToggle()}
      >
        EN
      </button>
      <button
        type="button"
        className={`${styles.toggleButton} ${language === 'ar' ? styles.active : ''}`}
        onClick={() => language !== 'ar' && onToggle()}
      >
        AR
      </button>
    </div>
  );
};

export default LanguageToggle;
